<form [formGroup]="setupForm">
  <div class="setup-intro">
    <p>
      Use this tile to show a simple promotional image. Provide the image source that should be
      rendered in the free trial tile.
    </p>
  </div>

  <mat-card>
    <mat-card-header>
      <mat-card-title>Settings</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field appearance="outline">
        <mat-label>Image</mat-label>
        <input matInput formControlName="background" />
        <mat-hint>Defines the image shown in the tile.</mat-hint>
      </mat-form-field>
    </mat-card-content>
  </mat-card>
</form>

<div class="footer">
  <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
</div>
